/**
 * Popin "Produit ajouté ✓" affiché sous l'icône panier du header.
 * Remplace l'animation fly-to-cart (R5, recette 2026-06).
 */
export class CartAddedPopin extends HTMLElement {
  static DURATION_MS = 3000;

  connectedCallback() {
    this.innerHTML = `
      <span class="cart-added-popin__icon svg-wrapper" aria-hidden="true"></span>
      <span class="cart-added-popin__text"></span>
      <span class="cart-added-popin__progress"></span>
    `;

    const iconTemplate = document.getElementById('cart-added-popin-icon');
    const icon = this.querySelector('.cart-added-popin__icon');
    if (iconTemplate instanceof HTMLTemplateElement && icon) {
      icon.appendChild(iconTemplate.content.cloneNode(true));
    } else if (icon) {
      icon.remove();
    }

    const text = this.querySelector('.cart-added-popin__text');
    if (text) text.textContent = this.dataset.message || 'Produit ajouté au panier';

    this.#position();
    window.addEventListener('resize', this.#position, { passive: true });

    requestAnimationFrame(() => {
      const bar = this.querySelector('.cart-added-popin__progress');
      if (bar) bar.style.animationDuration = `${CartAddedPopin.DURATION_MS}ms`;
    });

    this.#timeoutId = setTimeout(() => this.remove(), CartAddedPopin.DURATION_MS);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.#position);
    clearTimeout(this.#timeoutId);
  }

  /** @type {number | undefined} */
  #timeoutId;

  #position = () => {
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (!cartIcon) return;
    const rect = cartIcon.getBoundingClientRect();
    this.style.setProperty('--cart-popin-top', `${rect.bottom + 8}px`);
    this.style.setProperty('--cart-popin-right', `${window.innerWidth - rect.right}px`);
  };

  /**
   * @param {string} message
   */
  static show(message) {
    document.querySelectorAll('cart-added-popin').forEach((el) => el.remove());
    const popin = document.createElement('cart-added-popin');
    if (message) popin.dataset.message = message;
    document.body.appendChild(popin);
  }
}

if (!customElements.get('cart-added-popin')) {
  customElements.define('cart-added-popin', CartAddedPopin);
}
